<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Perfis e Permissões</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
				    <div class="p-field p-col-12 p-md-6">
                        <label>Perfil</label>
                        <Dropdown v-model="idPerfilSelecionado" :options="perfis" optionLabel="nome" optionValue="id" @change="selecionarPerfil"/>                       
					</div>  
                    <div class="p-field p-col-0">
						<label style="color:#ffffff">.</label>
						<span class="p-buttonset">
							<Button label="Novo" icon="pi pi-plus" v-if="permissaoNovo" @click="novo"/>
							<Button label="Detalhes" icon="pi pi-eye" class="p-button-success" v-if="permissaoEditar" @click="selecionarPerfilDetalhes"/>
							<Button label="Excluir" icon="pi pi-trash" class="p-button-danger" v-if="permissaoExcluir" @click="confirmarExcluir"/>
						</span>
					</div>                 
                </div>
                <div class="p-fluid p-formgrid p-grid" v-if="idPerfilSelecionado != null">				 
                    <div class="p-field p-col-12 p-md-6">                      
                        <div class="p-field-checkbox">
                            <Checkbox v-model="selecionarTodasPermissoes" :binary="true" @change="checkboxSelecionarTodasPermissoes"/>
                            <label>Todas permissões selecionadas</label>
                        </div>
					</div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
				    <div class="p-field p-col-12 p-md-6" v-if="idPerfilSelecionado != null">
                        <label>Itens do menu</label>
                        <ScrollPanel style="width: 100%; height: 500px">
                            <Tree :value="menu" :filter="true" filterMode="lenient" selectionMode="single" :selectionKeys.sync="idMenuSelecionado"
                                @node-select="itemMenuSelecionado"></Tree>
                        </ScrollPanel>                        
					</div>
                    <div class="p-field p-col-12 p-md-6" v-if="exibirPermissoes">
                        <label>Permissões</label>
                        <div v-for="permissao of permissoesItemMenuSelecionado" :key="permissao.id">
                            <div class="p-field-checkbox">
                                <Checkbox :id="permissao.id" v-model="permissao.selecionado" :binary="true" @change="validarSelecionados(permissao)"/>
                                <label v-if="permissao.principal" class="p-text-bold">{{permissao.nome}}</label>
                                <label v-else>{{permissao.nome}}</label>
                            </div>
                        </div>
					</div>
                </div>  
                <Button label="Salvar" icon="pi pi-check" v-if="idPerfilSelecionado != null" @click="salvar"/>                              
            </div>

            <Dialog :visible.sync="exibirDialogCadastro" header="Novo Perfil" :modal="true" class="p-fluid" :style="{width: '350px'}">			
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label for="nome">Nome</label>
                        <InputText id="nome" v-model.trim="novoPerfil.nome" required="true" autocomplete="off"/>
                        <small class="p-invalid" v-if="enviandoForm && !novoPerfil.nome">Informe o nome</small>
                    </div>					
                </div>	                	
                <template #footer>
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                    <Button label="Salvar" icon="pi pi-check" @click="incluirPerfil"/>
                </template>
            </Dialog>

            <Dialog :visible.sync="exibirDialogDetalhes" header="Detalhes do Perfil" :modal="true" class="p-fluid" :style="{width: '400px'}">			
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label>Permissões do perfil {{ perfilSelecionado.nome }}</label>
                        <Listbox :options="perfilSelecionado.permissoes" optionLabel="nome" :filter="true" dataKey="id" listStyle="height:250px">                            
                        </Listbox>
                    </div>					
                </div>	                	
                <template #footer>
                    <Button label="OK" icon="pi pi-check" @click="fecharModal"/>              
                </template>
            </Dialog>

            <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
                <div class="confirmation-content">
                    <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                    <span>Excluir perfil <b>{{ perfilSelecionado.nome }}</b>?</span>
                </div>
                <template #footer>
                    <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
                    <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
                </template>
            </Dialog>

        </div>
    </div>  
</template>

<script>
import PerfilPermissaoService from '@/service/PerfilPermissaoService';
import { exibirMensagem, exibirMensagemSis, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
    perfilPermissaoService: null,
    data() {
        return {
            perfilSelecionado: {nome: '', id: null, permissoes: []},
            novoPerfil: {nome: '', id: null, permissoes: []},
            enviandoForm: false,
            exibirDialogDetalhes: false,
            exibirDialogConfirmarExcluir: false,
            exibirDialogCadastro: false,
            permissaoNovo: false,
            permissaoEditar: false,
            permissaoExcluir: false,
            idMenuSelecionado: null,
            idPerfilSelecionado: null,
            exibirPermissoes: false,   
            selecionarTodasPermissoes: false,
            perfis: [],
            menu:[],
            todasPermissoesMenu: [],
            permissoesItemMenuSelecionado: [],
            indexIdNovoPerfil: 0,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        salvar() {
            let perfil = null;          
            for(let i = 0; i < this.perfis.length; i++) { 
                if(this.idPerfilSelecionado == this.perfis[i].id) {
                    perfil = clonar(this.perfis[i]);       
                    if(perfil.id < 0) {
                        perfil.id = null;
                    }             
                    break;
                }
            }            
            perfil.permissoes = [];
            let permissoes = [];
            this.todasPermissoesMenu.forEach(permissao => {
                if(permissao.selecionado) {                    
                    permissoes.push(permissao);                    
                }
            });
            let requisicao = {
                perfil: perfil,
                permissoes: permissoes,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.perfilPermissaoService.salvar(requisicao)
				.then(resp => {     
                    this.limpar();                
                    exibirMensagem(this, resp);	
                    this.fecharModal();
                    this.listarMenu();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },
        excluir() {
            let perfil = clonar(this.perfilSelecionado);
            perfil.pemisseos = [];
            let requisicao = {
                perfil: perfil,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.perfilPermissaoService.excluir(requisicao)
				.then(resp => {     
                    this.limpar();                
                    exibirMensagem(this, resp);	
                    this.limparExcluir();
                    this.listarMenu();
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        incluirPerfil() {
            this.enviandoForm = true;
            if(this.novoPerfil.nome != '') {
                this.indexIdNovoPerfil++;
                this.novoPerfil.id = this.indexIdNovoPerfil * -1;                
                this.perfis.splice(0, 0, {...this.novoPerfil});
                this.fecharModal();
                this.idMenuSelecionado = null;
                this.idPerfilSelecionado = null;
                this.exibirPermissoes = false; 
                this.selecionarTodasPermissoes = false;  
                this.permissoesItemMenuSelecionado = [];    
                exibirMensagemSis(this,'Sucesso', false);
            }
        },
        limparExcluir() {
			this.perfilSelecionado = {nome: '', id: null, permissoes: []};
			this.exibirDialogConfirmarExcluir = false;
		},
        fecharModal() {
            this.exibirDialogDetalhes = false,
            this.perfilSelecionado = {nome: '', id: null, permissoes: []};
            this.enviandoForm = false;
            this.novoPerfil = {nome: '', id: null, permissoes: []};         
            this.exibirDialogCadastro = false;
        },     
        novo() {
            this.novoPerfil = {nome: '', id: null, permissoes: []};            
            this.exibirDialogCadastro = true;
        },
        confirmarExcluir() {       
            for(let i = 0; i < this.perfis.length; i++) { 
                if(this.idPerfilSelecionado == this.perfis[i].id) {
                    this.perfilSelecionado = this.perfis[i];
                    this.exibirDialogConfirmarExcluir = true;
                    break;
                }
            } 
        },
        listarMenu() {	
			this.perfilPermissaoService.listarMenu({...this.getDadosRequisicao()})
				.then(resp => {   
                    this.menu = this.converterMenu(resp.data.menu);
                    this.perfis = resp.data.perfis;  
                })
                .catch(erro => {exibirMensagem(this, erro)});   
        },
        converterMenu(itensConverter) {
            let itens = [];
            itensConverter.forEach(me => {
                Array.prototype.push.apply(this.todasPermissoesMenu, me.permissoes);   
                let objMenu = {
                    key: me.id,
                    label: me.nome,
                    data: me.nome,
                    icon: '',
                    children: (me.menuFilhos.length > 0 ? this.converterMenu(me.menuFilhos): []),
                    permissoes: me.permissoes,
                }
                itens.push(objMenu);
            });
            return itens;
        },
        itemMenuSelecionado(itemMenu) {         
            if(itemMenu.children.length == 0) {
                this.exibirPermissoes = true;
                this.permissoesItemMenuSelecionado = [];
                itemMenu.permissoes.forEach(permissao => {                    
                    this.permissoesItemMenuSelecionado.push(permissao);
                });
            } else {
                this.permissoesItemMenuSelecionado = [];
                this.exibirPermissoes = false;
            }
            this.permissoesItemMenuSelecionado.sort((p1, p2)=>{
                if(p1.principal && !p2.principal) {
                    return -1;
                }
                if(!p1.principal && !p2.principal) {
                    return 0;
                }
            });
        },
        selecionarPerfilDetalhes() {
            for(let i = 0; i < this.perfis.length; i++) {                
                if(this.idPerfilSelecionado == this.perfis[i].id) {
                    this.perfilSelecionado = this.perfis[i];
                    this.exibirDialogDetalhes = true;
                    break;
                }
            }
        },
        selecionarPerfil() {
            let perfil = null;
            for(let i = 0; i < this.perfis.length; i++) {
                perfil = this.perfis[i];
                if(this.idPerfilSelecionado == perfil.id) {
                    break;
                }
            }
            if(perfil.permissoes.length == this.todasPermissoesMenu.length) {
                this.selecionarTodasPermissoes = true;
            } else {
                this.selecionarTodasPermissoes = false;
            }
            this.todasPermissoesMenu.forEach(permMenu => {
                let encontrei = false;
                for(let i = 0; i < perfil.permissoes.length; i++) {
                    let permissao = perfil.permissoes[i];
                    if(permissao.id == permMenu.id) {
                        permMenu.selecionado = true;
                        encontrei = true;
                        break;
                    }
                }
                if(!encontrei) {
                    permMenu.selecionado = false;
                }
            });            
        },
        checkboxSelecionarTodasPermissoes() {   
            this.todasPermissoesMenu.forEach(permissao => {                
                permissao.selecionado = this.selecionarTodasPermissoes;
            });            
        },
        validarSelecionados(permissaoCheck) {
            let qtdSelecionados = 0;
            let permissaoMenu = null;
            if(permissaoCheck.principal && !permissaoCheck.selecionado) {
                this.permissoesItemMenuSelecionado.forEach(permissao => {
                   permissao.selecionado = false;     
                });
            } else {
                this.permissoesItemMenuSelecionado.forEach(permissao => {
                    if(permissao.principal) {
                        permissaoMenu = permissao;                    
                    } else if(permissao.selecionado) {
                        qtdSelecionados++;
                    }
                });
            }            
            if(permissaoMenu != null) {
                if(qtdSelecionados > 0) {
                    permissaoMenu.selecionado = true;
                } else if(this.permissoesItemMenuSelecionado.length > 1) {
                    permissaoMenu.selecionado = false;
                }
            }
            let cont = 0;
            this.todasPermissoesMenu.forEach(permissao => {
                if(permissao.selecionado) {
                    cont++;
                }
            });          
            if(cont == this.todasPermissoesMenu.length) {
                this.selecionarTodasPermissoes = true;
            } else {
                this.selecionarTodasPermissoes = false;
            }             
        },   
        limpar() {
            this.idMenuSelecionado = null;
            this.idPerfilSelecionado = null;
            this.exibirPermissoes = false; 
            this.selecionarTodasPermissoes = false;
            this.perfis = [];
            this.menu = [];
            this.todasPermissoesMenu = [];
            this.permissoesItemMenuSelecionado = [];
            this.indexIdNovoPerfil = 0;
        }, 
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(8);
			this.permissaoEditar = permissoes.includes(9);
			this.permissaoExcluir = permissoes.includes(10);			
		}
    },
    created() {
        this.perfilPermissaoService = new PerfilPermissaoService();
    },
    mounted() {
        this.listarMenu();
        this.validarPermissoes();
    }
}
</script>

<style>

</style>